module.exports = __webpack_public_path__ + "img/food-34.88110c91.jpg";